import * as React from 'react';
import { styled } from '@mui/material/styles';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import { Button, Card, CardContent, CardMedia, InputAdornment, TextField, Typography } from '@mui/material';

import './mainBanner.css';

import IMG1 from '../../../assets/Landing/img1.png';
import IMG2 from '../../../assets/Landing/img2.png'; // You can use different images if needed.
import Contact_IMG from '../../../assets/Landing/contactus.png';
import { AccountCircle, Email, Send } from '@mui/icons-material';

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
  ...theme.applyStyles('dark', {
    backgroundColor: '#1A2027',
  }),
}));

export default function RowAndColumnSpacing() {
  return (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      style={{ minHeight: '100vh' }}
    >
      <Typography
        variant="h2"
        align="center"
        sx={{
          color: '#1C486A',
          textTransform: 'capitalize',
          margin: '-10px 0 20px 0',
          fontWeight: 'bold',
          '& span': {
            fontFamily: 'sans-serif',
            fontSize: 'inherit',
            WebkitTextFillColor: 'transparent',
            WebkitTextStroke: '1px #1C486A',
          },
        }}
      >
        Our <span>Services</span>
      </Typography>

      <Box sx={{ width: '90%' }}>
        <Grid container rowSpacing={5} columnSpacing={{ xs: 1, sm: 2, md: 5 }}>
          {/* Card 1: Online Bookkeeping Services */}
          <Grid item xs={12} sm={6}>
            <Card className="custom-card" sx={{ borderRadius: '25px', boxShadow: "0 10px 25px rgba(0, 0, 0, 0.25)" }}>
              <Grid container>
                <Grid item xs={6}>
                  <CardMedia
                    component="img"
                    image={IMG1} // You can replace with any image
                    alt="Online Bookkeeping"
                    className="card-image"
                    style={{ height: '320px' }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <CardContent>
                    <Typography variant="h5" component="div" gutterBottom>
                      Online Bookkeeping Services
                    </Typography>
                    <br/>
                    <Typography variant="body2" color="text.secondary">
                      Stay on top of your financials with our customized bookkeeping solutions. We handle accounts receivable, payable, reconciliations, and more, using cloud-based tools like Xero and QuickBooks.
                    </Typography>
                  </CardContent>
                </Grid>
              </Grid>
            </Card>
          </Grid>

          {/* Card 2: ICT Services */}
          <Grid item xs={12} sm={6}>
            <Card className="custom-card" sx={{ borderRadius: '25px', boxShadow: "0 10px 25px rgba(0, 0, 0, 0.25)" }}>
              <Grid container>
                <Grid item xs={6}>
                  <CardMedia
                    component="img"
                    image={IMG2} // You can replace with any image
                    alt="ICT Services"
                    className="card-image"
                    style={{ height: '320px' }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <CardContent>
                    <Typography variant="h5" component="div" gutterBottom>
                      ICT Services
                    </Typography>
                    <br/>
                    <Typography variant="body2" color="text.secondary">
                      Transform your technology landscape with our tailored ICT solutions, offering software development, data analytics, automation, and ERP support to drive digital transformation.
                    </Typography>
                  </CardContent>
                </Grid>
              </Grid>
            </Card>
          </Grid>

          {/* Card 3: Comprehensive Tax Solutions */}
          <Grid item xs={12} sm={6}>
            <Card className="custom-card" sx={{ borderRadius: '25px', boxShadow: "0 10px 25px rgba(0, 0, 0, 0.25)" }}>
              <Grid container>
                <Grid item xs={6}>
                  <CardMedia
                    component="img"
                    image={IMG1} // You can replace with any image
                    alt="Tax Solutions"
                    className="card-image"
                    style={{ height: '320px' }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <CardContent>
                    <Typography variant="h5" component="div" gutterBottom>
                      Comprehensive Tax Solutions
                    </Typography>
                    <br/>
                    <Typography variant="body2" color="text.secondary">
                      Navigate taxation with ease through our expert consultation and return submissions. We handle corporate and personal taxes, including VAT and TIN registration, ensuring compliance.
                    </Typography>
                  </CardContent>
                </Grid>
              </Grid>
            </Card>
          </Grid>

          {/* Card 4: Business Registration */}
          <Grid item xs={12} sm={6}>
            <Card className="custom-card" sx={{ borderRadius: '25px', boxShadow: "0 10px 25px rgba(0, 0, 0, 0.25)" }}>
              <Grid container>
                <Grid item xs={6}>
                  <CardMedia
                    component="img"
                    image={IMG2} // You can replace with any image
                    alt="Business Registration"
                    className="card-image"
                    style={{ height: '320px' }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <CardContent>
                    <Typography variant="h5" component="div" gutterBottom>
                      Business Registration
                    </Typography>
                    <br/>
                    <Typography variant="body2" color="text.secondary">
                      Streamline your business setup with our registration services for local and international markets. We ensure your business is registered efficiently and ready to operate.
                    </Typography>
                  </CardContent>
                </Grid>
              </Grid>
            </Card>
          </Grid>

          {/* Card 5: Company Secretarial Services */}
          <Grid item xs={12} sm={6}>
            <Card className="custom-card" sx={{ borderRadius: '25px', boxShadow: "0 10px 25px rgba(0, 0, 0, 0.25)" }}>
              <Grid container>
                <Grid item xs={6}>
                  <CardMedia
                    component="img"
                    image={IMG1} // You can replace with any image
                    alt="Company Secretarial Services"
                    className="card-image"
                    style={{ height: '320px' }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <CardContent>
                    <Typography variant="h5" component="div" gutterBottom>
                      Company Secretarial Services
                    </Typography>
                    <br/>
                    <Typography variant="body2" color="text.secondary">
                      Keep your business compliant with our secretarial services, handling filings, annual returns, and board resolutions with precision, ensuring legal adherence.
                    </Typography>
                  </CardContent>
                </Grid>
              </Grid>
            </Card>
          </Grid>

          {/* Card 6: Audit Services */}
          <Grid item xs={12} sm={6}>
            <Card className="custom-card" sx={{ borderRadius: '25px', boxShadow: "0 10px 25px rgba(0, 0, 0, 0.25)" }}>
              <Grid container>
                <Grid item xs={6}>
                  <CardMedia
                    component="img"
                    image={IMG2} // You can replace with any image
                    alt="Audit Services"
                    className="card-image"
                    style={{ height: '320px' }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <CardContent>
                    <Typography variant="h5" component="div" gutterBottom>
                      Audit Services
                    </Typography>
                    <br/>
                    <Typography variant="body2" color="text.secondary">
                      Enhance your financial transparency with our audit services. We perform external and internal audits to ensure accuracy and compliance, helping you make informed decisions.
                    </Typography>
                  </CardContent>
                </Grid>
              </Grid>
            </Card>
          </Grid>

          {/* Card 7: Legal Services */}
          <Grid item xs={12} sm={6}>
            <Card className="custom-card" sx={{ borderRadius: '25px', boxShadow: "0 10px 25px rgba(0, 0, 0, 0.25)" }}>
              <Grid container>
                <Grid item xs={6}>
                  <CardMedia
                    component="img"
                    image={IMG1} // You can replace with any image
                    alt="Legal Services"
                    className="card-image"
                    style={{ height: '320px' }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <CardContent>
                    <Typography variant="h5" component="div" gutterBottom>
                      Legal Services
                    </Typography>
                    <br/>
                    <Typography variant="body2" color="text.secondary">
                      Protect your business with our corporate legal services, including agreement preparation, trademark registration, and dispute resolution, ensuring legal compliance.
                    </Typography>
                  </CardContent>
                </Grid>
              </Grid>
            </Card>
          </Grid>
        </Grid>
      </Box>
      <Box sx={{ width: '100%', position: 'relative', marginTop: '72px' }}>
  <Grid item xs={12} sm={12}>
    <Card sx={{ backgroundColor: '#1C486A' }}>
      <Grid container>
        <Grid 
          item 
          xs={6} 
          sx={{ 
            display: { xs: 'none', md: 'flex' }, // Hide image on screens smaller than 500px
            justifyContent: 'center', 
            alignItems: 'center' 
          }}
        >
          <CardMedia
            component="img"
            image={Contact_IMG} // Replace with your image
            alt="Legal Services"
            style={{ height: '430px', width: '66%' }}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <CardContent sx={{ textAlign: { xs: 'center', md: 'left' } }}> {/* Center text on small screens */}
            <Typography 
              variant="h4" 
              component="div" 
              gutterBottom  
              color="#ffffff"
              sx={{ textAlign: { xs: 'center', md: 'left' } }} // Center "Contact Us" on small screens
            >
              Contact Us
            </Typography>
            <br />
            <form>
              <Grid container spacing={2}>
                {/* Name Field */}
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Full Name *"
                    variant="outlined"
                    helperText="Please enter your full name"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <AccountCircle sx={{ color: '#ffffff' }} />
                        </InputAdornment>
                      ),
                      style: { color: '#ffffff' }, // Input text color
                    }}
                    InputLabelProps={{
                      style: { color: '#ffffff' }, // Label color
                    }}
                    FormHelperTextProps={{
                      sx: { color: '#ffffff' }, // Helper text color
                    }}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        '& fieldset': { borderColor: '#ffffff' }, // Border color
                        '&:hover fieldset': { borderColor: '#ffffff' }, // Hover border color
                        '&.Mui-focused fieldset': { borderColor: '#ffffff' }, // Focused border color
                      },
                    }}
                  />
                </Grid>

                {/* Email Field */}
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Email Address *"
                    variant="outlined"
                    type="email"
                    helperText="Please enter your email address"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Email sx={{ color: '#ffffff' }} />
                        </InputAdornment>
                      ),
                      style: { color: '#ffffff' },
                    }}
                    InputLabelProps={{
                      style: { color: '#ffffff' },
                    }}
                    FormHelperTextProps={{
                      sx: { color: '#ffffff' },
                    }}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        '& fieldset': { borderColor: '#ffffff' },
                        '&:hover fieldset': { borderColor: '#ffffff' },
                        '&.Mui-focused fieldset': { borderColor: '#ffffff' },
                      },
                    }}
                  />
                </Grid>

                {/* Message Field */}
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Message *"
                    variant="outlined"
                    multiline
                    rows={4}
                    helperText="Please enter your message"
                    InputProps={{
                      style: { color: '#ffffff' },
                    }}
                    InputLabelProps={{
                      style: { color: '#ffffff' },
                    }}
                    FormHelperTextProps={{
                      sx: { color: '#ffffff' },
                    }}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        '& fieldset': { borderColor: '#ffffff' },
                        '&:hover fieldset': { borderColor: '#ffffff' },
                        '&.Mui-focused fieldset': { borderColor: '#ffffff' },
                      },
                    }}
                  />
                </Grid>

                {/* Submit Button */}
                <Grid item xs={12}>
                  <Button
                    fullWidth
                    variant="contained"
                    color="#ffffff"
                    endIcon={<Send />}
                    sx={{
                      color: '#ffffff',
                      backgroundColor: '#1C486A',
                      borderColor:'#ffffff',
                      border:'1px solid #ffffff',
                      '&:hover': {
                        backgroundColor: '#14536d',
                      },
                    }}
                  >
                    Send Message
                  </Button>
                </Grid>
              </Grid>
            </form>
          </CardContent>
        </Grid>
      </Grid>
    </Card>
  </Grid>
</Box>
    </Grid>
  );
}
